import React from "react";

import App from "./App";
import {LocalStoreProvider} from "./context/LocalStoreProvider";
import {SubdomainProvider} from "./context/SubdomainProvider";
import {AppUIControllerProvider} from "./context/AppUIControllerProvider";
import {ConfigProvider} from "./context/ConfigProvider";
import {ToastProvider} from "../common/fusion-ui/provider/ToastProvider";
import {Provider as ReduxProvider} from 'react-redux';
import {AuthProvider} from "./context/AuthProvider";
import {PersistGate} from 'redux-persist/integration/react';
import {sessionPersistor, store} from './redux/store';

const SiteRoot = React.memo(() => {
    return <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={sessionPersistor}>
            <AppUIControllerProvider>
                <LocalStoreProvider>
                    <ToastProvider>
                        <SubdomainProvider>
                            <AuthProvider>
                                <ConfigProvider>
                                    <App/>
                                </ConfigProvider>
                            </AuthProvider>
                        </SubdomainProvider>
                    </ToastProvider>
                </LocalStoreProvider>
            </AppUIControllerProvider>
        </PersistGate>
    </ReduxProvider>
});
export default SiteRoot;
